import { createStore } from "vuex";

export default createStore({
  state: {
    projects: [
      {
        type: "e-commerce",
        image: "vnoun.png",
        link: "https://vnoun.herokuapp.com",
        title: "vnoun | VueJS NodeJS Multi-Purpose E-Commerce website",
      },

      {
        type: "others",
        image: "egmask.png",
        link: "https://github.com/Ahmed-seyam/egmask.git",
        title: "egmask",
      },
      {
        type: "e-commerce",
        image: "natours.png",
        link: "https://github.com/Ahmed-seyam/natours.git",
        title: "Natours ",
      },

      {
        type: "Landing Pages",
        image: "Natours_design.png",
        link: "https://github.com/Ahmed-seyam/Natours-Design.git",
        title: "Natours ",
      },

      {
        type: "Landing Pages",
        image: "Nexter.png",
        link: "https://github.com/Ahmed-seyam/Nexter.git",
        title: "Nexter",
      },

      {
        type: "Landing Pages",
        image: "Trillo.png",
        link: "https://github.com/Ahmed-seyam/Trillo.git",
        title: "Trillo",
      },

      {
        type: "Landing Pages",
        image: "neon.png",
        link: "https://github.com/Ahmed-seyam/Neon-Agency.git",
        title: "Neon",
      },
    ],
  },
  getters: {
    getProjects(state) {
      return (type: string) => {
        // ["All", "UI & UX", "Landing Pages", "E-commerce", "Others"];
        if (type == "All") return state.projects;
        const projects = state.projects.filter(
          (project) => project.type.toLowerCase() == type.toLowerCase()
        );

        return projects;
      };
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});
